import { tabTypes } from "../constants/tab-types";

export const shouldRenderExtraContentSection = (tabType, toolData) => {
  const isMainTab = tabType === undefined || tabType === tabTypes.DETAILS;
  return !!(toolData && isMainTab);
};
